import type { AbortLike, Clock, Random } from '@visious/core';

/** R1 — `setTimeout`, `Date` and `Math.random` are banned inside core; they live here instead. */

export const systemClock: Clock = {
  nowEpochMs(): number {
    return Date.now();
  },

  sleep(ms: number, signal?: AbortLike): Promise<void> {
    return new Promise<void>((resolve) => {
      // Must never reject (core awaits it in the retry loop without a catch): an abort resolves
      // early and the caller re-checks `signal.aborted` itself.
      const timer = globalThis.setTimeout(resolve, ms);
      signal?.addEventListener('abort', () => {
        globalThis.clearTimeout(timer);
        resolve();
      });
    });
  },
};

export const systemRandom: Random = {
  next(): number {
    return Math.random();
  },
};
